<div class="bellows direction-{{direction}} {{#if stepper}}accordion-stepper{{/if}}">
{{#each bellows}}
  <div class="bellow-container item-{{@index}}">
    <header {{#if animation}}data-anijs="{{animation}}"{{/if}} role="heading" class="bellow-header header {{header_class}}" data-stepper-index="item{{#if ../stepper}}-stepper{{/if}}-{{@index}}">
      {{#if ../stepper}}
      <div class="horizontal-line"></div>
      <div class="bullet-step">
        <span class="number">{{indexToCount @index}}</span>
        {{>icon uuid=../cid index=@index icon="fal fa-check" classes="icon" sr_caption="Check icon for stepper"}}
      </div>
      {{/if}}
      {{#if icon_header_prefix}}
        <span class="header-icon">
          {{!-- legacy icon usage --}}
          {{>icon uuid=../cid index=@index prefix=icon_header_prefix classes=icon_header_classes name=icon_header sr_caption=header}}
        </span>
        {{else}}
        <span class="header-icon">
          {{>icon uuid=../cid index=@index icon=icon_header sr_caption=header}}
       </span>
      {{/if}}
      {{#if header_region}}
        <div data-region="{{../cid}}-header_region-{{@index}}-blocks"></div>
      {{/if}}
      <span id="accordion-header-{{../cid}}-{{@index}}" class="accordion-trigger"
            tabindex="0" role="button" aria-controls="bellow-{{../cid}}-{{@index}}"
            aria-label="{{#if sr_header_text}}{{{pt sr_header_text}}}{{t 'accordion.bellowCollapsed'}}{{else}}{{{pt header}}}{{t 'accordion.bellowCollapsed'}}{{/if}}" aria-expanded="false">
        {{#if forge_mode}}
          {{t header}}
        {{else}}
          <{{#if ../heading_level}}{{../heading_level}}{{else}}h2{{/if}}>
            {{{displayHeader}}}
          </{{#if ../heading_level}}{{../heading_level}}{{else}}h2{{/if}}>
        {{/if}}
      </span>
    </header>
    <article id="bellow-{{../cid}}-{{@index}}" class="bellow {{class}}"
             aria-hidden="true" role="region" aria-labelledby="accordion-header-{{../cid}}-{{@index}}" data-stepper-index="accor_content_{{#if ../stepper}}stepper_{{/if}}{{@index}}">
      {{#if description}}
        <div {{#if animation}}data-anijs="{{animation}}"{{/if}} class="description {{#if custom}}marked-down{{/if}} {{#if description_class}}{{description_class}}{{/if}}" tabindex="0">
          {{{t description}}}
        </div>
      {{/if}}

      {{#if body_region}}
        <div data-region="{{../cid}}-body_region-{{@index}}-blocks"></div>
      {{/if}}

    </article>
  </div>
{{/each}}
